import type { FailedInvoiceDeliveriesReportItem } from '@vy/types';
import { useMemo } from 'react';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import {
  collectUniqueOptions,
  filterNonEmptySelectFields,
  MULTISELECT_OPERATORS,
} from '../../reports-components/shared-filter-fields';

export const FAILED_DELIVERIES_FILTER_FIELD_IDS = Object.freeze({
  CUSTOMER: 'customer',
  REASON: 'reason',
});

export function useFailedDeliveriesFilterFields(
  rows: FailedInvoiceDeliveriesReportItem[],
): FilterField[] {
  return useMemo(() => {
    const customerOptions = collectUniqueOptions(rows.map((r) => r.customer.name));
    const reasonOptions = collectUniqueOptions(
      rows.map((r) => r.reason ?? 'Email could not be delivered'),
    );

    const allFields: FilterField[] = [
      {
        id: FAILED_DELIVERIES_FILTER_FIELD_IDS.CUSTOMER,
        label: 'Customer',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: customerOptions,
      },
      {
        id: FAILED_DELIVERIES_FILTER_FIELD_IDS.REASON,
        label: 'Reason',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: reasonOptions,
      },
    ];

    return filterNonEmptySelectFields(allFields);
  }, [rows]);
}
